import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import CommonBreadcrumb from "../../components/CommonBreadcrumb";
import { useGetBlogByIdQuery } from "../../service/blogs/api";
import { CircularProgress } from "@mui/material";
import moment from "moment";

const BlogDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  
  const { data, isLoading } = useGetBlogByIdQuery(id, {
    skip: !id,
  });

  const blog = data?.data;

  if (isLoading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: "50px" }}>
        <CircularProgress />
      </div>
    );
  }

  if (!blog) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: "50px" }}>
        <p>Blog not found.</p>
      </div>
    );
  }

  return (
    <>
      {/* Page Title */}
      <CommonBreadcrumb
        title="Blog Detail (تفاصيل المدونة)"
        breadcrumbItems={[
          { label: "Dashboard", onClick: () => navigate("/dashboard") },
          { label: "Blog Management", onClick: () => navigate("/manage-blogs-listings") },
          { label: "Blog Detail" },
        ]}
      />

      {/* General Information */}
      <div className="cards view_page mb_20">
        <div className="table_header mb_20">
          <h2>General Information (معلومات عامة)</h2>
          <span className={`status_btn dark ${blog.isActive ? "c_success" : "c_danger"}`}>
            {blog.isActive ? "Active" : "Inactive"}
          </span>
        </div>

        <div className="gap_p">
          {/* Blog Image */}
          <div className="vew_img v2 w_100">
            <h6>Blog Image (صورة المدونة)</h6>
            <figure className="no_radius" style={{ maxWidth: '400px' }}>
              <img alt="blog banner" src={blog.blogBannerImage || "/static/images/placeholder.png"} />
            </figure>
          </div>

          {/* Additional Blog Images */}
          {blog.blogImages && blog.blogImages.length > 0 && (
            <div className="w_100" style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '10px' }}>
              {blog.blogImages.map((img: string, idx: number) => (
                <figure key={idx} className="no_radius" style={{ width: '150px', height: '100px' }}>
                  <img alt={`blog secondary ${idx}`} src={img} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </figure>
              ))}
            </div>
          )}

          {/* Blog Title */}
          <div className="w_33">
            <h6>Blog Title</h6>
            <p>{blog.blogTitle}</p>
          </div>

          {/* Blog Title Arabic */}
          <div className="w_33">
            <h6>عنوان المدونة</h6>
            <p>{blog.blogTitle_ar || "-"}</p>
          </div>

          {/* Created Date */}
          <div className="w_33">
            <h6>Created Date (تاريخ الإنشاء)</h6>
            <p>{moment(blog.createdAt).format("DD MMM YYYY")}</p>
          </div>

          {/* Blog Description */}
          <div className="w_50">
            <h6>Blog Description</h6>
            <p>{blog.blogDescription}</p>
          </div>

          {/* Blog Description Arabic */}
          <div className="w_50">
            <h6>وصف المدونة</h6>
            <p>{blog.blogDescription_ar || "-"}</p>
          </div>

          {/* Blog Content */}
          <div className="w_50">
            <h6>Blog Content</h6>
            <div
              className="blog_content_html"
              style={{ marginTop: '10px' }}
              dangerouslySetInnerHTML={{ __html: blog.blogContent }}
            />
          </div>

          {/* Blog Content Arabic */}
          <div className="w_50">
            <h6>محتوى المدونة</h6>
            <div
              className="blog_content_html"
              style={{ marginTop: '10px' }}
              dangerouslySetInnerHTML={{ __html: blog.blogContent_ar || "-" }}
            />
          </div>
        </div>
      </div>

      {/* Author Detail */}
      <div className="cards view_page">
        <div className="table_header mb_20">
          <h2>Author Detail (تفاصيل المؤلف)</h2>
        </div>

        <div className="gap_p">
          {/* Author Image */}
          <div className="vew_img w_33">
            <h6>Author Image (صورة المؤلف)</h6>
            <figure>
              <img alt="author" src={blog.authorImage || "/static/images/placeholder.png"} />
            </figure>
          </div>

          {/* Author Name */}
          <div className="w_33">
            <h6>Author Name</h6>
            <p>{blog.authorName}</p>
          </div>

          {/* Author Name Arabic */}
          <div className="w_33">
            <h6>اسم المؤلف</h6>
            <p>{blog.authorName_ar || "-"}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogDetail;
